import Vue from 'vue';
import Vuex from 'vuex';

import {
  breadcrumb,
  config,
  inspectionDocument,
  labelTagging,
  overlaps,
  session,
  spherical,
  workpacks,
} from './modules';
import { MeasurementUnit, WorkpackReload } from '../utils';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

const getSavedOrDefault = (key, defaultValue) => {
  try {
    return localStorage.getItem(key) || defaultValue;
  } catch {
    return defaultValue;
  }
};

const trySave = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Ignore error
  }
};

const initialState = {
  workpackReload: WorkpackReload.SERVER,
  unit: getSavedOrDefault('numericUnit', MeasurementUnit.IMPERIAL),
};

const getters = {
  numericUnit: (state) => state.unit,
  workpackReload: (state) => state.workpackReload,
};

const actions = {
  setUnit({ commit }, unit) {
    trySave('numericUnit', unit);
    commit('setUnit', unit);
  },
  setWorkpackReload({ commit }, reload) {
    commit('setWorkpackReload', reload);
  },
};

const mutations = {
  setUnit(state, unit) {
    state.unit = unit;
  },
};

export default new Vuex.Store({
  modules: {
    breadcrumb,
    config,
    inspectionDocument,
    labelTagging,
    overlaps,
    session,
    spherical,
    workpacks,
  },
  strict: debug,
  plugins: [],
  state: initialState,
  getters,
  actions,
  mutations,
});
